// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"17484b88","421":"627cdeaa","449":"9e4a119f","716":"0904765f","763":"713bb1bf","932":"d988ce8a"}[chunkId] + ".chunk.js";
};